<script>
    import { fly } from "svelte/transition";
    import { Image } from "../index";
    const src = "https://cdn.cnbj1.fds.api.mi-img.com/mi-mall/5d1892854c8bb165e755d68bde287d71.jpg?w=632&h=340";

</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <Image src={src}/>
    </div>
    <h4 class="example-title">多种填充模式</h4>
    <div class="example-body bg" >
        <Image src={src} width={"200px"} height={"100px"} fit='fill' />
        <br>
        <Image src={src} width={"200px"} height={"100px"} fit='contain' />
        <br>
        <Image src={src} width={"200px"} height={"100px"} fit='cover' />
        <br>
        <Image src={src} width={"200px"} height={"100px"} fit='scale-down' />
        <br>
        <Image src={src} width={"200px"} height={"100px"} fit='none' />
    </div>
    <h4 class="example-title">自定义圆角</h4>
    <div class="example-body">
        <Image src={src} width={"100px"} height={"100px"} borderRadius="10px"/>
        <br>
        <Image src={src} width={"100px"} height={"100px"} borderRadius="20px"/>
        <br>
        <Image src={src} width={"100px"} height={"100px"} borderRadius="100%"/>
    </div>
    <h4 class="example-title">lazy</h4>
    <div class="example-body">
        <Image src={src} width={"351px"} height="188px" lazy/>
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .bg {
        background-color: white;
    }
</style>
